import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { toast } from "sonner";
import { X, Loader2, Bot } from "lucide-react";

export function ChatTranscriptModal({ enquiry, onClose }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!enquiry) return;
    let cancelled = false;
    (async () => {
      try {
        const r = await api.get(`/admin/enquiry/${enquiry.id}/chat-transcript`);
        if (!cancelled) setData(r.data);
      } catch (e) {
        if (!cancelled) toast.error(e?.response?.data?.detail || "Could not load transcript");
      }
      if (!cancelled) setLoading(false);
    })();
    return () => { cancelled = true; };
  }, [enquiry]);

  if (!enquiry) return null;
  const messages = data?.messages || [];

  return (
    <div className="fixed inset-0 z-[75] bg-black/50 flex items-center justify-center p-4" onClick={onClose}>
      <div className="bg-white w-full max-w-xl max-h-[85vh] flex flex-col" onClick={(e) => e.stopPropagation()} data-testid="chat-transcript-modal">
        <div className="flex items-center justify-between px-5 py-3.5 bg-[#12263A] text-white shrink-0">
          <div>
            <div className="label-eyebrow text-[#C79A3B] flex items-center gap-1.5"><Bot size={12} /> Daisy chatbot transcript</div>
            <div className="text-sm font-black">{enquiry.name || enquiry.email || "Visitor"}</div>
          </div>
          <button data-testid="chat-transcript-close" onClick={onClose} className="text-white/80 hover:text-white"><X size={20} /></button>
        </div>
        <div className="flex-1 overflow-y-auto p-4 space-y-3 bg-[#F8F6F2]">
          {loading && <div className="py-8 text-center text-sm text-[#6B7280]"><Loader2 size={15} className="animate-spin inline mr-2" /> Loading conversation…</div>}
          {!loading && messages.length === 0 && (
            <div className="py-8 text-center text-sm text-[#9CA3AF]" data-testid="chat-transcript-empty">No transcript on file for this enquiry.</div>
          )}
          {messages.map((m, i) => (
            <div key={`${m.ts}-${i}`} className={`flex ${m.role === "user" ? "justify-end" : "justify-start"}`} data-testid={`chat-transcript-msg-${i}`}>
              <div className={`max-w-[85%] px-3 py-2 text-sm whitespace-pre-wrap ${
                m.role === "user" ? "bg-[#C79A3B] text-white" : "bg-white border border-[#E5E7EB] text-[#12263A]"}`}>
                <div className="text-[9px] uppercase tracking-widest font-black opacity-70 mb-0.5">
                  {m.role === "user" ? "Visitor" : "Daisy"}{m.ts ? ` · ${new Date(m.ts).toLocaleString("en-GB")}` : ""}
                </div>
                {m.content}
              </div>
            </div>
          ))}
        </div>
        <div className="px-5 py-2.5 border-t border-[#E5E7EB] text-[11px] text-[#6B7280] shrink-0" data-testid="chat-transcript-count">
          {messages.length} message{messages.length === 1 ? "" : "s"}{data?.session_id ? ` · session ${data.session_id.slice(0, 8)}…` : ""}
        </div>
      </div>
    </div>
  );
}
